import { fetchPrePedidoDetalhe } from "./fetchPrePedidosForExport";
import exportPrePedidosToXlsx from "./exportPrePedidosXlsx";

export default async function exportSinglePrePedido(pedidoRow) {
  const id =
    pedidoRow?.IdVitrineVirtualB2bPedido ??
    pedidoRow?.idVitrineVirtualB2bPedido;

  if (id == null) {
    throw new Error("ID do pré-pedido não encontrado");
  }

  const detalhe = await fetchPrePedidoDetalhe(id);

  exportPrePedidosToXlsx({
    pedidos: [pedidoRow],
    detalhes: detalhe ? [detalhe] : [],
    idPedido: id,
  });
}
